<form>
  <mat-form-field>
    <mat-label>{{ placeholder }}</mat-label>
    <input
      type="text"
      placeholder="{{ placeholder }}"
      aria-label="Assignee"
      matInput
      [formControl]="myControl"
      [matAutocomplete]="auto"
      [readonly]="disabled"
      [required]="required"
    />
    <mat-autocomplete
      style="background-color: white"
      (optionSelected)="onOptionSelected($event.option.value)"
      #auto="matAutocomplete"
      [displayWith]="displayFn"
    >
      <mat-option *ngIf="createOption !== ''" [value]="create">
        <i
          style="color: #28b463"
          class="fa fa-plus-circle"
          aria-hidden="true"
        ></i>
        &nbsp; <b>{{ createOption }}</b>
      </mat-option>

      <mat-option
        *ngFor="let option of filteredOptions | async"
        [ngStyle]="{ disabledOpot: unable(option.id) }"
        [disabled]="unable(option.id)"
        [value]="option"
      >
        {{ option.name }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</form>
